import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import { API_BASE_URL } from '../../config/serverApiConfig';
import { Modal, Button } from 'react-bootstrap';
import * as apiService from '../../services';
import "./LoginPage.css"; // Custom CSS for the login page

const UserLogin = () => {
  const [data, setData] = useState({ user: "", password: "" });
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [email, setNewemail] = useState('');
  const [changePasswordmsg, setchangePasswordmsg] = useState('');
  const navigate = useNavigate();

  const handleChange = ({ currentTarget: input }) => {
    setData({ ...data, [input.name]: input.value });
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      const url = API_BASE_URL + "/sbdriverlogin";
      const { data: res } = await axios.post(url, data);

      if (res.user_data && res.user_login) {
        const user = res.user_data[0];
        const fullName = `${user.FirstName} ${user.LastName}`;
        const street = user.Street || "";
        const fullAddress = `${street} ${user.CurrentCity} ${user.CurrentState}`;
        localStorage.removeItem("token");
        localStorage.setItem("token1", res.user_login);
        localStorage.setItem('user1_data', JSON.stringify(user));
        localStorage.setItem("registrationNo", user.companyid);
        localStorage.setItem("userid", user.DriverId);
        localStorage.setItem("useremail", user.DriverEmail);
        localStorage.setItem("driveraddress", fullAddress);
        localStorage.setItem("drivername", fullName);
        localStorage.setItem("driverphone", user.PhoneNumber);
        localStorage.setItem("driverZip", user.ZipCode);

        // Fetch user assessments
        const requestOptions = {
          method: 'POST',
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ "userid": user.DriverId, "companyassid": localStorage.getItem('reg') }),
          redirect: 'follow'
        };

        const response = await fetch("https://casaahaanahotels.com/get_user_assessments", requestOptions);
        const result = await response.json();

        if (result.Assessments) {
          console.log(result);
          localStorage.setItem('assessment_id', result.Assessments);
        } else if (result.assessments) {
          localStorage.setItem('assessment_id', result.assessments);
        }

        // Redirect to /user
        window.location = "/user";
      } else {
        setError(res.Message);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        setError(error.response.data.Message);
      } else {
        setError("An unexpected error occurred.");
      }
    }
  };

  const [showChangePass, setShowChangePass] = useState(false); // new state for modal
  const [changePasswordMsg, setChangePasswordMsg] = useState("");

  const handleCloseChangePassword = () => {
    setShowChangePass(false);
  };

  const handleChangePassword = () => {
    setShowChangePass(true);
  };

const handlePasswordChange = async () => {
    try {
      // 1. Reset password via the forgetPassword service
      const response = await apiService.forgetdriverPassword(email);
      console.log(response);
      setChangePasswordMsg(response.Message);

      // 2. Build the email payload for the new mail API
      const payload = {
        email: email,
        name: response.name,
        subject: "Your Password Reset Information",
        message: `
          <body style="font-family:Arial,sans-serif;background-color:#f4f4f4;margin:0;padding:0">
            <div class="container" style="width:70%;margin:30px auto;background:#fff;padding:20px;box-shadow:0 0 15px rgba(0,0,0,0.2);border-radius:8px;text-align:center">
              <div class="header" style="margin-bottom:20px">
                <img src="https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg" alt="Company Logo" style="width:auto;height:100px;">
              </div>
              <div class="content" style="text-align:left;line-height:1.6">
                <h4 style="margin-top:0">Your Password Reset Information</h4>
                <p style="font-size:16px;">Dear ${response.name},</p>
                <p style="font-size:16px;">
                  Your password for Star Behaviors has been reset as requested today. Below are your new login details:
                  <br><b>Username:</b> ${response.email},<br><b>Password:</b> ${response.tempPassword}
                </p>
                <p style="font-size:16px;">Please log in to your Star Behaviors account using the following link:</p>
                <p style="font-size:16px;">
                  <a href="https://sb.starbehaviors.com/" style="color:#06c;text-decoration:none">Star Behaviors Login</a>
                </p>
                <p style="font-size:16px;">
                  If you did not initiate this password reset request, please contact our support team immediately at
                  <a href="mailto:support@starbehaviour.com" style="color:#06c;text-decoration:none">support@starbehaviour.com</a>.
                </p>
                <p style="font-size:16px;">Thank you for choosing Star Behaviors!<br>Best regards,</p>
              </div>
              <div class="footer" style="margin-top:20px;font-size:0.9em;color:#555">
                Star Behaviors Support
              </div>
            </div>
          </body>
        `,
      };

      // 3. Send email using the new mail API
      const mailResponse = await fetch("https://bakemywords.com/mailchimp/sendmail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        mode: "no-cors", // <-- no-cors
      });

      // In typical no-cors or opaque responses, you may not get a JSON body
      // If you do, parse it:
      const result = await mailResponse.json();
      console.log(result);
    } catch (error) {
      console.error("Error changing password:", error);
    }
  };

  return (
    <>
      <div className="sb-login-page-container">
        <div className="sb-login-card">
          <h4 className="sb-login-card-header text-uppercase">User Login</h4>
          <div className="sb-login-card-body">
            {showChangePass && (
              <Modal show={showChangePass} onHide={handleCloseChangePassword} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Forgot Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <label>Email</label>
                  <br />
                  <input
                    className="form-control"
                    placeholder="Enter Your Email"
                    type="email"
                    value={email}
                    onChange={(e) => setNewemail(e.target.value)}
                  />
                  <span style={{ color: "red" }}>{changePasswordMsg}</span>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseChangePassword}>
                    Close
                  </Button>
                  <Button variant="primary" onClick={handlePasswordChange}>
                    Submit
                  </Button>
                </Modal.Footer>
              </Modal>
            )}
            <form onSubmit={handleSubmit} className="sb-login-form">
              <div className="form-floating mb-3 sb-login-form-floating">
                <input
                  id="emailAddress"
                  className="form-control sb-login-input"
                  type="email"
                  name="user"
                  onChange={handleChange}
                  value={data.user}
                  required
                  placeholder="Email Address"
                />
                <label htmlFor="emailAddress" className="sb-login-label">
                  Email Address
                </label>
              </div>
              <div className="input-group mb-3">
                <div className="form-floating flex-fill sb-login-form-floating">
                  <input
                    id="password"
                    className="form-control sb-login-input"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    onChange={handleChange}
                    value={data.password}
                    required
                    placeholder="Password"
                  />
                  <label htmlFor="password" className="sb-login-label">
                    Password
                  </label>
                </div>
                <button
                  className="btn btn-outline-secondary sb-login-toggle-btn"
                  type="button"
                  onClick={handleTogglePasswordVisibility}
                >
                  <Icon icon={showPassword ? "oi:eye" : "oi:eye"} />
                </button>
              </div>
              {error && <div className="sb-login-error">{error}</div>}
              <div className="sb-login-btn-group">
                <button type="submit" className="sb-login-btn">
                  Login
                </button>
                <button
                  className="sb-login-btn-secondary "
                  type="button"
                  onClick={handleChangePassword}
                >
                  Forgot Password
                </button>
              </div>
            </form>
            <ul className="nav nav-pills nav-justified mt-3">
              <li className="nav-item">
                <a
                  className="nav-link text-decoration-underline small p-2"
                  href="https://sb.starbehaviors.com/imgs/StarBehaviorsPrivacyPolicy.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link text-decoration-underline small p-2"
                  href="https://sb.starbehaviors.com/imgs/StarBehaviorsUserAgreement.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  User Agreement
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserLogin;
